import Vuex from "vuex";
import Vue from "vue";
import VueResource from "vue-resource";
import ShopCheckout from './app/shop-checkout.vue';
import { shopCheckoutStore } from "./store/shopCheckoutStore";
import VueI18n from "vue-i18n";
import {countries} from "@global/utilities/global-country-data";

export const shopCheckout = {
    init: () => {
        const shopShell = document.getElementById('shop-wish-cart');
        if (shopShell !== null) {
            Vue.use(VueResource);
            Vue.use(Vuex);
            Vue.use(VueI18n)

            new Vue({
                store: shopCheckoutStore,
                i18n: new VueI18n({
                    locale: 'shop', // set locale
                    messages: {'shop': Object.assign({}, window.jsI18N.shopCart, window.jsI18N.globalAddressAdministration, {"countries": countries()}, window.jsI18N.wishlist)} // set locale messages
                }),
                render: h => h(ShopCheckout, {
                    props: {
                        _mode: shopShell.dataset.mode,
                    }
                })
            }).$mount('#shop-wish-cart');
        }
    }
};
